---
pageId: concept-insights
title: Statystyki i wnioski
description: Jak Samlla zamienia wpisy w zrozumienie — widoki Statystyk, linie bazowe i trendy per tracker.
category: concepts
order: 4
lang: pl
slug: koncepty/wnioski
updated: 2026-11-01
---

Statystyki Samlli obserwują; nie oceniają. Nie ma celów do zawalenia ani ostrzegawczych kolorów — tylko Twoje dane, porównane z Twoją własną historią, opisane neutralnym językiem. Wnioski żyją na czterech powierzchniach.

## Strona Statystyk

**Statystyki** pokazują wszystkie trackery razem w czterech skalach — **Tydzień**, **Miesiąc**, **Kwartał** i **Rok** — każdą w dwóch trybach okresu: **Kalendarzowym** (wyrównane tygodnie i miesiące) lub **Kroczącym** (ostatnie 7 dni, ostatnie 6 tygodni, ostatnie 90 dni).

Każdy widok łączy:

- **Pasek podsumowania** — aktywności i czas treningu, ze zmianą procentową ze znakiem, gdy okres już się domknął.
- **Heatmapę aktywności** — godziny w przekroju tygodnia w widoku tygodniowym, dni w przekroju okresu w szerszych. Gęstość widać w kryciu; najechanie odsłania dokładne liczby.
- **Karty trackerów** — główna wartość, mini-wykres per dzień, a w widoku tygodniowym dwa spokojne porównania: z poprzednim tygodniem i z medianą Twoich aktywnych tygodni.
- **Trendy kwartału** — jak każdy tracker poruszył się w ciągu kwartału, posortowane po wielkości zmiany.
- **Rekordy z oglądanego okresu** — jedna sekcja łączy najlepszy pojedynczy wpis i nadal obowiązujący rekord tygodnia, miesiąca lub roku. Każdy wiersz nazywa typ rekordu i odniesienie delty; pełna historia pozostaje na stronie trackera. Wyparte rekordy okresowe nie są odtwarzane w starszych widokach. Wszystko jest podane jako fakt, bez fanfar.

Wszystko możesz filtrować po kategorii (rekurencyjnie), trackerze lub tagach.

## Gdzie jestem — domyślna zakładka trackera

Każdy tracker otwiera się na pytaniu, które naprawdę zadaje każdy: co jest dla mnie typowe? Zakładka **Gdzie jestem** buduje linię bazową z Twojej historii i odpowiada słowami: „zwykle 21 km", „W okolicach Twojego typowego poziomu", „Więcej niż Twój typowy poziom", „Tendencja rosnąca". Linia trajektorii dodaje spokojną projekcję — przy tym tempie, gdzie skończy się miesiąc. Gdy historia jest za krótka, Samlla mówi to wprost i pokazuje zwykłe liczby, zamiast udawać, że wie.

## Insights — głęboki wgląd w tracker

Zakładka **Insights** patrzy na jeden tracker w oknie 30, 90, 365 dni albo całości: trendy w czasie, rozkłady („wtorek to Twój dzień", gdzie zwykle lądują Twoje wartości), korelacje między metrykami trackera oraz 365-dniowa heatmapa aktywności z licznikiem aktywnych dni.

## Free i Pro

Free obejmuje każdy widok Statystyk, także Rok, z 90 dniami widocznej historii. Wcześniejsze dni pozostają w rocznym układzie jako zamaskowane pola. Pro odblokowuje pełną historię i usuwa limity planu na trackery, metryki i kategorie.
